import { useEffect, useRef, useState } from "react";
import { submitWmtIntro } from "../service/api";
import PageWrapper from "./PageWrapper"; 

const WMTIntro = ({ userId, onNext }) => {
  const [startTime] = useState(Date.now());
  const saveInFlight = useRef(false);
  const [saveError, setSaveError] = useState("");

  useEffect(() => {
    const handleKeyDown = async (event) => {
      if (event.code === "Space") {
        event.preventDefault();
        if (saveInFlight.current) return;
        saveInFlight.current = true;
        setSaveError("");

        const endTime = Date.now();
        const elapsedSeconds = Math.floor((endTime - startTime) / 1000);

        try {
          await submitWmtIntro({
            userId,
            wmtIntroTimestamp: new Date(startTime).toISOString(),
            wmtIntroElapsed: elapsedSeconds,
          });
          onNext();
        } catch (err) {
          console.error("❌ Failed to save WMTIntro:", err);
          setSaveError("We could not save this step. Press the spacebar to try again.");
        } finally {
          saveInFlight.current = false;
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onNext, userId, startTime]);

  return (
    <PageWrapper>
      <h2 style={{ textAlign: "center" }}>🧠 Step 2: Visual Working Memory Task</h2>

      <p>
        You will now complete a visual working memory task. Before you begin, please read the instructions carefully.
      </p>

      <p>
        Once the task starts, you will see a <b>grid made up of square tiles</b>. Some of these tiles will be <b>colored blue</b>.
        After <b>two seconds</b>, the colors will disappear, and your task is to <b>mark the exact tiles</b> that were previously blue on an empty grid.
        You can <b>select and deselect tiles</b> by clicking on them with the <b>left mouse button</b>.
        When you are ready to submit your answer, <b>press the spacebar</b>.
      </p>

      <p>
        Pay attention - the grids will gradually <b>increase in size</b> as the task progresses.
        In some trials, <b>a few tiles may also appear in orange</b> - these are distractors and should be ignored.
      </p>

      <p style={{ textAlign: "center", fontSize: "var(--font-size-sm)", fontWeight: "bold", color: "var(--color-info)" }}>
        Press the <b>spacebar</b> to begin the practice round.
      </p>
      {saveError && <p className="alert alert-error" role="alert">{saveError}</p>}
    </PageWrapper>
  );
};

export default WMTIntro;
